import { IConfig } from '@unleash/proxy-client-react';

export const unleashConfig = {
  url: process.env.REACT_APP_UNLEASH_PROXY,
  disableRefresh: process.env.NODE_ENV !== 'production',
  disableMetrics: process.env.NODE_ENV !== 'production',
  clientKey: process.env.REACT_APP_UNLEASH_CLIENT_KEY,
  refreshInterval: 60,
  appName: process.env.REACT_APP_UNLEASH_APP_NAME,
  environment: process.env.REACT_APP_UNLEASH_ENVIRONMENT,
} as IConfig;

export const unleashFeatureToggles = {
  PAGE_DASHBOARD: 'page.dashboard',
  PAGE_SERVICE_INTERRUPTIONS: 'page.service_interruptions',
};
